export default {"src":"/_next/static/media/pool.90f14293.svg","height":12,"width":22,"blurWidth":0,"blurHeight":0};